let distance = {
    toDiv: function(div) {
        const el = document.querySelector(div);
        let distance = Math.round(el.getBoundingClientRect().top);

        return distance;
    },
    toDivFromBottom: function(div) {
        const el = document.querySelector(div);
        const windowHeight = window.innerHeight;
        let distance = Math.round(el.getBoundingClientRect().top) - windowHeight;

        return distance;
    },
    toTop: function() {
        return window.scrollY || window.pageYOffset || document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0);
    }
}

module.exports = { distance };